import React from 'react';
import { Header } from '../components/Header';
import { EligibilityCalculator } from '../components/EligibilityCalculator';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { CalcBreadcrumb, CalcRelatedLinks } from '../components/CalcBreadcrumb';

const EligibilityCalculatorPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <WhatsAppButton />
      
      {/* Page Header */}
      <div className="bg-white pt-24 sm:pt-28 md:pt-32 pb-10 sm:pb-12">
        <div className="container mx-auto px-4">
          <CalcBreadcrumb name="Loan Eligibility Calculator" path="/calculators/eligibility" />
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-3 sm:mb-4 text-center leading-[1.1]">
            Loan Eligibility <span className="text-emerald-600">Calculator</span>
          </h1>
          <p className="text-base sm:text-lg text-slate-600 text-center max-w-2xl mx-auto">
            Find out how much loan you can get based on your income and financial profile
          </p>
          <CalcRelatedLinks links={[['Home Loan', '/home-loan'], ['Business Loans', '/business-loans']]} />
        </div>
      </div>

      {/* Calculator Section */}
      <EligibilityCalculator />
      
      <Footer />
    </div>
  );
};

export default EligibilityCalculatorPage;
